<template>
  <div>
    <div v-if="currentPageIndex === 0" class="text-center hide--mobile">
      <h2 v-if="isAutoSelectedRoof" class="h4">
        På dette taket er det
        <br />
        <span style="color: #67BEA2">veldig gode</span> solforhold!
      </h2>
      <p style="font-size: 16px">
        <span v-if="isAutoSelectedRoof">
          Vi har automatisk valgt taket som er best egnet for solkraft. </span
        >Beregningen viser hvor mye solkraft du kan produsere med
        <span style="font-weight: 700">{{ panel.antallPaneler }}</span> paneler
        på valgt tak.
        <br />
        <!-- <br />Logg inn under for å se beregningene målt mot ditt faktiske
        strømforbruk.
      </p> -->
      </p>
    </div>

    <div class="production-card">
      <div class="production-card-content">
        <svg viewBox="0 0 36 36" class="circular-chart">
          <defs>
            <pattern
              id="img1"
              patternUnits="userSpaceOnUse"
              width="100"
              height="100"
            >
              <image
                class="consumption-logo"
                :xlink:href="imagePath + '/img/ikon-hus.svg'"
                height="18px"
                width="14px"
                x="29%"
                y="22%"
              />
            </pattern>
          </defs>
          <image
            class="consumption-logo"
            :xlink:href="imagePath + '/img/ikon-hus.svg'"
            height="18px"
            width="14px"
            x="29%"
            y="22%"
          />
          <path
            class="circle-bg"
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          />
          <path
            class="circle"
            :stroke-dasharray="strokeDasharray"
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            fill="url(#img1)"
          />
        </svg>
        <div class="info-box">
          <span>
            Est. årlig
            <br />produksjon
          </span>
          <span class="number">{{ production | Thousands }}</span>
          <span>kWh</span>
        </div>
        <div class="info-box">
          <span>
            Est. dekket
            <br />forbruk
          </span>
          <span class="number">{{ coveredConsumption }}</span>
          <span>%</span>
        </div>
        <div class="info-box">
          <span>
            Est. årlig
            <br />besparelse
          </span>
          <span class="number">{{ annualSaving | Thousands }}</span>
          <span>kr</span>
        </div>
      </div>
      <!-- <div
        class="production-card-footer"
        @click.prevent.stop="showSmsLoginModal"
        @mouseover="isLoginBtnMouseover = true"
        @mouseleave="isLoginBtnMouseover = false"
      >
        {{
          selectedActor
            ? isLoginBtnMouseover
              ? 'Bytt kundeforhold'
              : `Innlogget - ${selectedActor.addressLine1}`
            : 'Logg inn'
        }}
      </div> -->
    </div>
  </div>
</template>

<script>
import store from '../store';
import Thousands from '../../common/filters/Thousands';

export default {
  name: 'ProductionInformation',
  filters: {
    Thousands,
  },
  data() {
    return {
      annualSaving: 0,
      coveredConsumption: 0,
      isLoginBtnMouseover: false,
      production: 0,
    };
  },
  methods: {
    animateValue(id, start, end) {
      start = Math.round(start);
      end = Math.round(end);
      const duration = 600;
      const range = end - start;
      const minTimer = 0;
      var stepTime = Math.abs(Math.floor(duration / range));
      stepTime = Math.max(stepTime, minTimer);
      const startTime = new Date().getTime();
      const endTime = startTime + duration;
      let timer;
      const run = () => {
        const now = new Date().getTime();
        const remaining = Math.max((endTime - now) / duration, 0);
        const value = Math.round(end - remaining * range);
        this[id] = value;
        if (value === end) {
          clearInterval(timer);
        }
      };
      timer = setInterval(run, stepTime);
    },
    showSmsLoginModal() {
      store.dispatch('smsLogin/showSmsLoginModal');
    },
  },
  watch: {
    panel(newVal, oldVal) {
      if (newVal.kwtAar !== oldVal.kwtAar) {
        this.animateValue(
          'annualSaving',
          oldVal.kwtAar * this.elPriceKWh,
          newVal.kwtAar * this.elPriceKWh
        );

        const newCoveredConsumptionPercentage = Math.round(
          (newVal.kwtAar / this.annualConsumption) * 100
        );
        const oldCoveredConsumptionPercentage = Math.round(
          (oldVal.kwtAar / this.annualConsumption) * 100
        );
        this.animateValue(
          'coveredConsumption',
          oldCoveredConsumptionPercentage,
          newCoveredConsumptionPercentage
        );

        this.animateValue('production', oldVal.kwtAar, newVal.kwtAar);
      }
    },
  },
  computed: {
    annualConsumption() {
      return (
        store.state.smsLogin.deliveryPoint.consumptionPreviousYear ||
        store.state.avgAnnualConsumption
      );
    },
    coveredConsumptionPercentage() {
      const coveredConsumption = Math.round(
        (store.state.panelsVal.kwtAar / this.annualConsumption) * 100
      );
      return coveredConsumption;
    },
    currentPageIndex() {
      return store.state.currentPageIndex;
    },
    elPriceKWh() {
      return store.state.elPriceKWh;
    },
    panel() {
      return store.state.panelsVal;
    },
    selectedActor() {
      return store.state.smsLogin.selectedActor;
    },
    strokeDasharray() {
      return `${this.coveredConsumptionPercentage}, 100`;
    },
    imagePath() {
      return store.state.imagePath;
    },
    isAutoSelectedRoof() {
      return store.state.isAutoSelectedRoof;
    },
  },
  mounted() {
    this.annualSaving = this.panel.kwtAar * this.elPriceKWh;
    this.coveredConsumption = Math.round(
      (this.panel.kwtAar / this.annualConsumption) * 100
    );
    this.production = this.panel.kwtAar;
  },
};
</script>

<style>
.text-center {
  text-align: center;
}

.production-card {
  color: #003451;
  width: 100%;
}

.production-card-content,
.production-card-footer {
  display: flex;
  background-color: #fff;
  width: 100%;
  border-radius: 0rem;
  padding: 0 1rem;
}

.production-card-content {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
  font-size: 14px;
  padding: 1rem;
}

.production-card-footer {
  justify-content: center;
  align-items: center;
  height: 2rem;
  font-size: 14px;
  font-weight: 700;
  border: 0.1rem solid transparent;
  transition: background-color 0.1s ease-out, border-color 0.1s ease-out,
    box-shadow 0.1s ease-out;
  cursor: pointer;
}

.production-card-footer:hover {
  background-color: #003451;
  border-color: #fff;
  color: #fff;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.4);
  transition: background-color 0.1s ease-out, border-color 0.1s ease-out,
    box-shadow 0.1s ease-out;
}

.info-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
}

@media (max-width: 47.99em) {
  .info-box {
    font-size: 12px;
  }
}

.circular-chart {
  display: block;
  height: 4rem;
  border-radius: 50%;
}

.circle-bg {
  fill: none;
  stroke: #dbe5ec;
  stroke-width: 0.2rem;
}

.circle {
  stroke: #67bea2;
  stroke-width: 0.15rem;
  stroke-linecap: round;
  animation: progress 0.6s ease-out forwards;
}

@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}

.info-box .number {
  color: #67bea2;
  font-size: 22px;
  font-weight: 700;
  padding-top: 0.25rem;
}
</style>
